<template>
	<div>
		<div class="game flash multi" :class="'multi-' + inkey" v-show="!reaction" :style="params.users > 1 ? 'border-color:' + colors[inkey] : ''">
			<div class="game__name" v-if="role === 'teacher'" :class="users > 5 ? 'game__name--wrap' : ''">
				Игрок {{ inkey }}
				<div class="game__settings" @click="setShowsettings"></div>
			</div>
			<div class="train__info">
				<div class="train__item" uk-tooltip="Шаг">
					<div class="train__ico train__ico--1"></div>
					<small>Шаг:</small>
					{{ local_steps }}
				</div>
				<div class="train__item" uk-tooltip="Ошибок сделано">
					<div class="train__ico train__ico--2"></div>
					<small>Ошибок:</small>
					{{ errors }}
				</div>
				<div class="train__item" v-if="$route.params.isHomework" uk-tooltip="Выполнено упражнений">
					<div class="train__ico train__ico--4"></div>
					<small>Выполнено:</small>
					<div class="train__nowrap">{{ $route.params.total }} из {{ $route.params.qnt }}</div>
				</div>
				<div class="train__item" uk-tooltip="Времени прошло">
					<div class="train__ico train__ico--3"></div>
					<span><!--<small>Времени прошло:</small>-->
					{{ timer.minutes }} мин. {{ timer.seconds }} сек.</span>
				</div>
			</div>

			<div v-if="is_error" class="flash__message flash__error">Неправильно! <span v-html="result"></span></div>
			<div v-if="is_success" class="flash__message flash__success">Правильно! <span v-html="result"></span></div>
			<!--ИГРА-->
			<div v-if="current_step === 'start'">
				<div class="multi__primer">
					<!--<span :style="'font-size: calc(1em / 1.' + ((users > 9) ? 99 : users) + ');'">{{ primer }}</span>-->
					<span>{{ primer }}</span>
				</div>
				<div class="">
					<input type="text" :id="'game_input-' + inkey" class="uk-input game_input" autocomplete="off" @keyup.enter="nextStep2" v-model="userNumber" placeholder="Введите ответ">
				</div>
				<button class="uk-button uk-button-primary" @click="nextStep">Ответить</button>
			</div>
			<!--КОНЕЦ ИГРЫ-->
			<div v-else>
				<h2 class="uk-margin-top">Закончено</h2>
				<p>Ваши результаты:</p>
				<div v-for="(result, key) in results" :key="result.id">
					<p><strong>Шаг: {{ key+1 }}: </strong>
						<span>{{ result.primer }}</span>
						<!--{{ result.cifers.join('  ') }}-->
						= {{ result.sum }}, Ваш ответ: {{ result.user_answer }}
						<span class="mental__checks" :class="(+result.user_answer === result.sum) ? '' : 'active'"></span></p>
				</div>
				<p class="scores">Ты зарабатываешь
					<strong>{{ scores }}</strong> {{ $root.getNoun(scores, 'балл', 'балла', 'баллов') }}!</p>
				<button class="uk-button uk-button-primary" :id="'repeat-' + inkey" v-if="!checkHomeworkFinish()" @click="reStartGame">Повторить</button>
				<button class="uk-button uk-button-primary" @click="onStopTrainer" v-else>Закончить</button>
			</div>
			<a v-if="users === 1" href="#" @click.prevent="onStopTrainer">Остановить</a>
		</div>

		<div class="modsettings" v-show="showsettings">
			<div class="modsettings__back" @click="setShowsettings"></div>
			<div class="modsettings__body">
				<h2>Настройки тренажера Игрока {{ inkey }}</h2>
				<div class="instructions">
					<settings :inparams="params" :ingame="true" @params_changed="params_changed"></settings>
				</div>
				<!--<div class="modsettings__button">
					<button class="uk-button uk-button-primary" @click="setShowsettings">Применить</button>
				</div>-->
			</div>
		</div>

		<div class="wh-block wh-block--reaction" v-if="reaction">
			<div class="reaction">
				<!--<video loop muted preload="auto" autoplay @ended="reaction = !reaction">-->
				<video disableRemotePlayback preload="auto" autoplay @ended="stopReaction">
					<source type="video/mp4" :src="'/storage/app/media/reactions/' + reaction_file" id="mp4">
				</video>
			</div>
		</div>
	</div>
</template>

<script>
  import { mapState, mapMutations } from 'vuex';
  import { mix } from "../mixin";
  import settings from "./components/Settings";
  import axios from "axios";

  export default {
    name: "game",
    mixins: [
      mix
    ],
    components: {
      settings
    },
    data() {
      return {
        errors: 0,
        counter: 1,
        userNumber: '',
        is_success: false,
        is_error: false,
        primer: '',
        answer: '',
        result: '',
        first: 0,
        second: 0,
        try: 1,
        current_step: 'start',
        finish: false,
        results: [],
        local_results: [],
        local_steps: 0,
        scores: 0,
        stat_id: '',
        showsettings: false,
        params: '',
        /** Реакции */
        reaction: false,
        reaction_file: '',
        react_minus: [
          'muzyka_kostochek_-.mp4',
          'chtoby_stat_supergeroem_-.mp4',
          'davay_ya_seychas_zakroyu_glaza.mp4',
          'po-moemu_ya_chto-to_zabyl._ty_schitay_poka.mp4',
          'schitay_a_ne_vitay_v_oblakah.mp4',
          'tolko_vpered._ne_oglyadyvaysya_nazad.mp4',
          'pomogite.mp4',
          '01_dzhenias._idi_syuda-.mp4',
          '02_ne_boysya._ne_sem-.mp4',
          '03_te._kto_ne_razgadal_golovolomku-.mp4',
          '04_dostavay_abakus_i_treneruysya-.mp4',
          '05_kristally_nuzhno_zasluzhit-.mp4',
          '01_-_ne_vremya_grustit.mp4',
          '02_-_ne_vremya_veshat_nos.mp4',
          '03_-_ne_spi._drug.mp4',
          '04_-_budte_ostrymi.mp4',
        ],
        react_plus: [
          'priznavaysya_.mp4',
          'tolko_nikomu__.mp4',
          'aplodismenty_v_kruge.mp4',
          'aplodismenty.mp4',
          'vot_eto_skorost.mp4',
          'uau._ty_-_supergeroy.mp4',
          'hochu_posmotret_na_togo_supergeroya.mp4',
          'ey._podozhdi_menya._ya_za_toboy_ne_uspevayu.mp4',
          '01_ya_ne_veryu_svoim_glazam!_eto_fantastika!_+.mp4',
          '02_ya_rada_+.mp4',
          '03_yohou!_+.mp4',
          '04_vot_eto_skorost!_+.mp4',
          '05_molodec_drug!_+.mp4',
          '06_vy_porazili_menya!_+.mp4',
          '05_-_vasha_snorovka_vozhd.mp4',
          '06_-_molodcy_(logiya).mp4',
          '07_-_my_molodcy!_a_teper_mozhno_i_pospat.mp4',
          '08_-_ura._srabotalo.mp4',
          '09_-_ura.mp4',
          '10_-_ura!_na_ostrove.mp4',
          '11_-_ya_veryu_v_vas.mp4',
        ],
      }
    },
    props: {
      inkey: ''
    },
    computed: {
      ...mapState({
        //params: state => state.train.multi_params
      }),
      users() {
        return this.$store.state.train.multi_params.users;
      },
      user() {
        return this.$store.state.user;
      },
      colors() {
        return this.$store.state.colors;
      },
      role() {
        return this.user.role.code;
      },
    },
    methods: {
      setStatus(val) {
        let app = this;
        this[val] = true;
        setTimeout(function () {
          app[val] = false;
        }, 1000)
      },
      /** Проверяем ошибки */
      checkError() {
        this.userNumber = Number(this.userNumber.replace(/^(-)|[^0-9.]+/g, ''));

        let result = {
          primer: this.primer,
          cifers: [this.first, this.second],
          sum: +this.answer,
          user_answer: +this.userNumber,
          timer: this.timer
        };
        this.results.push(result);
        this.local_results.push(result);
        
        if (+this.answer === this.userNumber) {
          this.result = this.answer + " = " + this.userNumber;
          this.setStatus('is_success');
        } else {
          this.result = this.answer + " <span class='fn'>≠</span> " + this.userNumber;
          this.setStatus('is_error');
          this.errors++;
        }
        this.startReaction();
      },

      /** Следующий шаг */
      nextStep2() {
        if (this.users > 1) {
          this.$root.$emit('fullCheck');
        } else {
          this.nextStep();
        }
      },
      nextStep() {
        if (this.userNumber && !this.result) {
          this.checkError();
          let app = this;
          console.log(this.params)
          if (this.counter === +this.params.qnt) {
            this.current_step = 'finish';
            this.finish = true;
            this.addScores();
            if (this.local_steps > 1 && this.stat_id) {
              this.updateStats();
            } else {
              this.makeStats();
            }

            setTimeout(function () {
              if (app.users > 1) {
                //$('#start').focus();
              } else {
                $('#repeat-' + app.inkey).focus();
              }
            }, 100);
          } else {
            setTimeout(function () {
              app.counter++;
              app.startGame();
              app.result = '';
              app.userNumber = '';
              //app.result = '';
            }, 1500);
          }
        }

      },

      /** Генерируем пример */
      generatePrimer() {
        let formula;
        if (this.params.formula !== 'mix') {
          formula = this.params.formula.split('-');
          let hasFactor = this.params.hasFactor;
          let factor = this.params.factor;
          let c2;
          let c1 = this.randomNumber(+formula[0]).join('');
          if (hasFactor && factor !== '*') {
            c2 = factor;
          } else {
            c2 = this.randomNumber(+formula[1]).join('');
          }

          let primer = c1 + ' * ' + c2;
          let answer = +c1 * +c2;
          this.primer = primer;
          this.answer = answer;

        }
      },

      /** Генерируем случайное число */
      randomNumber(qnt, step) {
        let ret = [];
        for (let i = 1; i < qnt + 1; i++) {
          ret.push(this.randomInteger((i > 1 ? 0 : 1), 9));
        }
        return ret;
      },

      /** ГЕНЕРАТОРЫ И ПОДГОТОВКА */
      prepareNumbers() {
        this.first = _.join(this.generateNumber(this.params.first), '');
        this.second = _.join(this.generateNumber(this.params.second), '');
      },

      /** Генерируем число */
      generateNumber(num) {
        let first = num.first;
        let second = num.second;
        let digits = num.digits;
        let cifers = [];
        for (let i = 1; i <= digits; i++) {
          let n = (i === 1 || this.params.type === 'divisi') ? first : second;
          let cif = this.generateCif(n, i);
          cifers.push(cif);
        }
        return cifers;
      },

      /** Возвращаем количество чисел после запятой */
      numDigitsAfterDecimal(x) {
        var afterDecimalStr = x.toString().split('.')[1] || ''
        return afterDecimalStr.length
      },

      /** Генерируем цифру из массива */
      generateCif(arr, step) {
        if (arr.length > 0 && this.try < 250) {
          return _.sample(arr);
        } else {
          return this.randomNumber(1, step);
        }
      },

      /** Создаем пример */
      makePrimer() {
        let type = this.params.type;
        if (type === 'multi') {
          this.prepareNumbers();
          this.local_steps++;
          this.letMulti();
        } else if (type === 'divisi') {
          this.startDivisi();
        }
      },

      /** Применяем умножение **/
      letMulti() {
        this.primer = this.first + ' x ' + this.second;
        this.answer = this.first * this.second;
      },

      /** СТАРАЯ!!! Применяем деление **/
      letDivisi() {
        console.log('Divisi', this.first, this.second);
        let hasRemainder = this.params.hasRemainder;
        let digitsRemainder = this.params.digitsRemainder;
        let sum = this.first / this.second;
        console.log('SUM', sum);

        /** ЕСЛИ ЕСТЬ ОСТАТОК ОТ ДЕЛЕНИЯ */
        if (hasRemainder) {
          if (Number.isInteger(sum) || (digitsRemainder > 1 && this.numDigitsAfterDecimal(sum) === 1)) {
            console.log('Перегенерируем на дробное');
            this.try++;
            this.startGame();
            return false;
          } else {
            sum = sum.toFixed(digitsRemainder);
            console.log('Дробное', sum);
          }

          /** ЕСЛИ НЕТ ОСТАТКА ОТ ДЕЛЕНИЯ */
        } else {
          if (Number.isInteger(sum)) {

          } else {
            console.log('Перегенерируем на целое');
            this.try++;
            this.startGame();
            return false;
          }
        }

        console.log('Финальная сумма', sum);
        this.local_steps++;
        this.primer = this.first + ' ÷ ' + this.second;
        this.answer = sum;
        this.try = 1;
      },

      /***
       * НОВЫЕ ФУНКЦИИ ДЕЛЕНИЯ
       * */

      /** 1. СТАРТОВАЯ ТОЧКА ДЕЛЕНИЯ */
      startDivisi() {
        //console.log('Старт деления');
        let hasRemainder = this.params.hasRemainder;
        let first, second;

        /** Генерируем первый номер */
        first = this.generateFirst();
       // console.log(first);

        /** Если есть остаток, запускаем генерацию второго числа*/
        if (hasRemainder) {
	        this.generateReminderDivisiNumbers(first);
        }
        /** Если нет, то просто генерируем второе и обрезаем до нужного */
        else {
          second = this.generateWholeDivisiNumbers(first);
          let sum = this.first / this.second;
          
          if (second) this.finishDivisi(sum);
        }
      },

      /** 2. Генерируем делимое для деления без остатка */
      generateWholeDivisiNumbers(num) {
        let vars = this.findPosibleDividents(num);

        if (vars.length > 0) {
          this.first = num;
          return this.choiceDivisiVar(vars);
        } else {
          let first = this.generateFirst();
          return this.generateWholeDivisiNumbers(first);
        }

      },

      /** 3. Выбираем один из ста вариантов! */
      choiceDivisiVar(vars) {
        let numbers = this.params.second.first;
        if (numbers.length > 0) {
          let re_vars = _.filter(vars, (i) => {
            return _.indexOf(numbers, i) !== -1;
          });
          if (re_vars.length > 0) vars = re_vars;
        }
        return this.second = _.sample(vars);
      },

      /** 4. Завершаем путь деления */
      finishDivisi(sum) {
        this.local_steps++;
        this.primer = this.first + ' ÷ ' + this.second;
        this.answer = sum;
        this.try = 1;
      },

	    /** Деление с остатком */
      generateReminderDivisiNumbers() {
        let digitsRemainder = this.params.digitsRemainder;
        let first = this.generateFirst();
        let second = this.generateSecond();

        let sum        

        if (this.params.remainderAnswer) {
          let remainder = first % second
          sum = Number(Math.floor(first / second) + '.' + remainder)
        } else {
          sum = first / second;
        }

        if (Number.isInteger(sum) || (digitsRemainder > 1 && this.numDigitsAfterDecimal(sum) === 1)) {
          //console.log('Перегенерируем на дробное');
          this.try++;
          return this.generateReminderDivisiNumbers();
        } else {
          sum = sum.toFixed(digitsRemainder);
          //console.log('Дробное', sum);
          this.first = first;
          this.second = second;
          this.finishDivisi(sum);
        }
      },


      /**
       * Вспомогательные функции
       * */
      generateFirst() {
        return _.join(this.generateNumber(this.params.first), '');
      },
      generateSecond() {
        return _.join(this.generateNumber(this.params.second), '');
      },

      /** Находим возможные делимые числа */
      findPosibleDividents(num) {
        let range = this.findMinMaxNumberInRank(this.params.second.digits);

        // if (range.min > num / 2) {
        //   console.log('Делимое больше делителя. Не выйдет');
        //   if(this.params.second.digits > 0) this.params.second.digits--;
        //   return false;
        // }

        let array = [];
        for (let i = range.min; i <= range.max; i++) {
          if (+num % i === 0 && +num !== i)  {
            array.push(i);
          }
        }
        if (array.length > 1) {
          return array;
        } else {
          console.log('Нет вариантов');
          this.try++;
          return false;
        }
      },

      /** Получаем разряд числа */
      countRanks(num) {
        if (num < 0) num = -num;
        return num.toString().length;
      },

      /** Получаем минимальное и максимальное число выбранного разряда*/
      findMinMaxNumberInRank(rank) {
        //console.log('Генерируем мин и макс', rank);
        let min = [];
        let max = [];
        for (let i = 1; i <= rank; i++) {
          if (i === 1) {
            min.push('1');
            max.push('9');
          } else {
            min.push('0');
            max.push('9');
          }
        }
        return {
          'min': Number.parseInt(_.join(min, '')),
          'max': Number.parseInt(_.join(max, ''))
        }
      },


      /**
       * Запуск игры
       * */
      startGame() {
        console.log('Start game');
        this.makePrimer();
        let app = this;
        setTimeout(function () {
          if (app.users > 1) {
            $('#game_input-1').focus();
          } else {
            $('#game_input-' + app.inkey).focus();
          }
        }, 150);
      },
      /** Перезапуск игры */
      reStartGame() {
        console.log('Перезапуск игры');
        this.$root.wait = false;
        let app = this;
        this.scores = 0;
        this.results = [];
        this.result = '';
        this.try = 1;
        this.finish = false;
        this.current_step = 'start';
        this.counter = 1;
        this.userNumber = '';
        this.primer = '';
        this.makePrimer();

        this.checkFz();
        this.startTimer();
        setTimeout(function () {
          if (app.users > 1) {
            $('#game_input-1').focus();
          } else {
            $('#game_input-' + app.inkey).focus();
          }
        }, 150);
      },


      checkFz() {
        let block = $('.multi-' + this.inkey).find('.multi__primer span');
        let primer_length = this.primer.length;
        block.css('font-size', 'calc(1em / 1.' + (primer_length > 9 ? 99 : primer_length) + ')');

      },

      params_changed(val) {
        this.params = val;
        //this.current_step = 'finish';
        this.finish = true;
        let app = this;
        setTimeout(function () {
          app.reStartGame();
        }, 1000)
      },
      setShowsettings() {
        this.showsettings = !this.showsettings;
        if (this.showsettings) {
          $(document.body).addClass('fixed');
        } else {
          $(document.body).removeClass('fixed');
        }
      },

      /*** Реакции */
      startReaction() {
        if (this.users === 1 && this.params.show_reactions && this.params.qnt === 1) {

          let type = (this.answer == this.userNumber ? 'react_plus' : 'react_minus');

          this.reaction_file = this.checkReaction(type);
          //console.log(reaction);
          this.reaction = true;
          setTimeout(function () {
            UIkit.scroll('.headline2').scrollTo('.wh-block--reaction');
          }, 100);
        }
      },
      stopReaction() {
        this.reaction = false;
        let app = this;
        setTimeout(function () {
          UIkit.scroll('.headline2').scrollTo('.game__body');
          //$('#repeat-' + app.inkey).focus();
        }, 100);
      },
      fullReStart() {
        this.finish = true;
        let app = this;
        this.$root.wait = true;
        setTimeout(function () {
          app.$root.wait = false;
          app.reStartGame();
        }, 1000);
      },
      /** Баллы */
      addScores() {
        console.log('Add scores');
        let sum = 0;
        let result = this.results;

        result.forEach(function (e) {
          if (e.sum === e.user_answer) {
            let cif1 = e.cifers[0].toString().length;
            let cif2 = e.cifers[1].toString().length;
            sum = sum + (cif1 * cif1) * (cif2 * cif2);
          } else {
            console.log('Ошибки не считаем');
          }
        });
        sum = Math.ceil(sum);

        if (this.$route.params.isHomework) {
          sum = Math.ceil(sum * this.$store.state.hw_coefficient);
        }
        this.checkScoreStatus(sum);
        this.scores = sum;
        this.$store.commit('changeUserScores', sum);
        console.log('Баллов заработано', sum);
      },
      /** Статистика */
      makeStats() {
        console.log("Make stats");
        if (this.user.role.code === 'student') {
          console.log('Бережно сохраняем статистику');
          //let time = this.timer;
          let app = this;
          let errors = this.errors;
          let train_params = this.params;
          let stats = {
            //time: time,
            total: this.getTotalTime(this.local_results),
            errors: errors,
            user_id: this.$store.state.user.id,
            trainer: this.$store.state.current_trainer.id,
            results: this.results,
            count: this.local_steps,
            scores: this.scores,
            train_params: {
              type: train_params.type,
              qnt: train_params.qnt,
              first: train_params.first.digits,
              second: train_params.second.digits,
              has_remainder: train_params.hasRemainder
            }
          }

          stats = this.checkHomework(stats);
          //this.$store.dispatch('saveStats', stats);
          console.log(stats);

          axios.post(window.location.href, { 'stat': stats }, {
            headers: {
              'X-OCTOBER-REQUEST-HANDLER': 'onSaveStats',
              'X-Requested-With': 'XMLHttpRequest'
            }
          }).then(function (res) {
            //console.log(res);
            app.stat_id = res.data.id;
            app.checkCoins(res.data);
          });


        } else {
          console.log('Учителей в статистику не заносим! Понятно?!');
        }
      },
      updateStats() {
        if (this.user.role.code === 'student') {
          console.log('Update stats');
          let results = this.local_results;
          let time = this.getTotalTime(results);
          let stat_id = this.stat_id;
          let arr = {
            result: results,
            time: time,
            errors: this.errors,
            stat_id: stat_id,
            count: this.local_steps,
            scores: this.scores,
            isHomework: this.$route.params.isHomework ? true : false
          }
          //console.log(arr);
          this.updateHomework();
          axios.post(window.location.href, { 'stat': arr }, {
            headers: {
              'X-OCTOBER-REQUEST-HANDLER': 'onUpdateStats',
              'X-Requested-With': 'XMLHttpRequest'
            }
          }).then((res) => {
            //console.log(res);
            this.checkCoins(res.data);
          });

        }
      },
      getTotalTime(arr) {
        return _.reduce(arr, function (sum, i) {
          return sum + i.timer.total_ms;
        }, 0);
      }
    },
    mounted() {
      this.params = this.$store.state.train.multi_params;
      console.log('params', this.params)
      this.reStartGame();
      this.$root.$on('fullCheck', this.nextStep);
      this.$root.$on('fullStart', this.fullReStart);
      //this.generatePrimer();
      //this.startTimer();
    },
    beforeDestroy() {
      this.$root.$off('fullCheck', this.nextStep);
      this.$root.$off('fullStart', this.fullReStart);
      if (this.users === 1) {
        //this.$parent.commitVal(false, 'start')
      }
    }
  }
</script>